export default "__VITE_ASSET__BaBGGYKV__"